{
  "name": "affinite-sweets",
  "version": "1.0.223",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "prebuild": "npm --no-git-tag-version version patch",
    "build": "ng build",
    "watch": "ng build --watch --configuration development",
    "test": "ng test"
  },
  "private": true,
  "dependencies": {
    "@affinite/common": "^0.0.10",
    "@angular/animations": "^19.2.14",
    "@angular/cdk": "^19.2.19",
    "@angular/common": "^19.2.14",
    "@angular/compiler": "^19.2.14",
    "@angular/core": "^19.2.14",
    "@angular/forms": "^19.2.14",
    "@angular/material": "^19.2.19",
    "@angular/platform-browser": "^19.2.14",
    "@angular/platform-browser-dynamic": "^19.2.14",
    "@angular/router": "^19.2.14",
    "@auth0/angular-jwt": "^5.1.2",
    "@kolkov/angular-editor": "^3.0.0-beta.0",
    "@microsoft/applicationinsights-web": "^3.0.2",
    "@microsoft/signalr": "^9.0.6",
    "@ng-idle/core": "^16.0.0",
    "@ng-idle/keepalive": "^16.0.0",
    "@popperjs/core": "^2.11.8",
    "@primeng/themes": "^19.1.4",
    "bn-ng-idle": "^2.0.5",
    "css-fx-layout": "^3.0.5",
    "html2canvas": "^1.4.1",
    "jspdf": "^3.0.1",
    "libphonenumber-js": "^1.12.12",
    "lodash": "^4.17.21",
    "luxon": "^3.7.1",
    "moment": "^2.29.4",
    "moment-timezone": "^0.6.0",
    "momentjs": "^2.0.0",
    "ngx-mask": "^20.0.3",
    "oidc-client": "^1.11.5",
    "pdfmake": "^0.2.20",
    "pdfmake-unicode": "^0.0.1",
    "powerbi-client-angular": "^5.0.0",
    "powerbi-report-authoring": "^2.0.0",
    "primeicons": "^7.0.0",
    "primeng": "^19.1.4",
    "print-js": "^1.6.0",
    "quill": "2.0.3",
    "rxjs": "~7.8.0",
    "stream": "^0.0.2",
    "sweetalert2": "^11.10.7",
    "tslib": "^2.3.0",
    "zone.js": "^0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^19.2.15",
    "@angular/cli": "^19.2.15",
    "@angular/compiler-cli": "^19.2.14",
    "@types/jasmine": "~4.3.0",
    "@types/lodash": "^4.14.197",
    "@types/luxon": "^3.6.2",
    "@types/node": "^20.5.4",
    "@types/readable-stream": "^4.0.21",
    "jasmine-core": "~4.6.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.0.0",
    "ng-packagr": "^19.2.2",
    "typedoc": "^0.28.10",
    "typescript": "~5.8.3"
  }
}
